import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';
import { ButtonStepComponent } from '../../step/button-step/button-step.component';

@Component({
  selector: 'app-property-status',
  templateUrl: '../../step/button-step/button-step.component.html',
  styleUrls: ['../../step/step.component.scss', '../../step/button-step/button-step.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class PropertyStatusComponent extends ButtonStepComponent implements OnInit {

  title: string = "Do you own or rent this property?";
  buttonList = [
    { text: 'Own', value: 'Own', imageName: 'single-family', default: true },
    { text: 'Rent', value: 'Rent', imageName: 'investment-property' },
    { text: 'Other', value: 'Other', imageName: 'secondary-home' },
  ];

  ngOnInit() {
    this.control = new UntypedFormControl('', Validators.required);
    this.form.addControl('housingSituation', this.control);
  }

  shouldRedirectToPLOffers(value: string): boolean {
    return value === 'Rent';
  }

  submit(button) {
    if (button.value === 'Rent') {
      this.analyticsService.trackGoal(111);
      console.log('111');
    } else if (button.value === 'Own') {
      this.analyticsService.trackGoal(112);
      console.log('112');
    } else if (button.value === 'Other') {
      console.log('113');
      this.analyticsService.trackGoal(113);
    }

    super.submit(button);
  }

}
